export default "__VITE_ASSET__Big2aJAH__"